import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileHistoricSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}historicalFiles/${COMMON_QUERY_PARAMS.FILE_ID}`;

interface GetHistoricFileInfoArgs {
  fileId: string;
}

export const getHistoricFileInfo = async ({
  fileId,
}: GetHistoricFileInfoArgs): Promise<
  BackResponse<FileHistoricSummary> | BackResponseFailure
> => {
  const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

  try {
    const response = await apiCall<BackResponse<FileHistoricSummary>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
